import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";
import mollie_button from "../../img/mollie_button.png";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import PaymentIcon from "@material-ui/icons/Payment";
import InfoIcon from "@material-ui/icons/Info";
import LaunchIcon from "@material-ui/icons/Launch";
import IconButton from "@material-ui/core/IconButton";

export default class MollieConnectDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.signupPage.mollieConnect}
        </DialogTitle>
        <DialogContent style={{ width: 500, maxWidth: "97%", paddingTop: 0 }}>
          <DialogContentText />
          <div>
            {this.props.mollieConnected ? (
              <div>
                <div>
                  <Typography style={{ marginBottom: 10 }}>
                    <PaymentIcon
                      style={{ verticalAlign: "middle", marginRight: 10 }}
                    />
                    {languages.signupPage.mollieConnected}
                    <AutorenewIcon
                      style={{
                        cursor: "pointer",
                        verticalAlign: "middle",
                        marginLeft: 10,
                        color: "red",
                        fontSize: 18,
                      }}
                      onClick={this.props.handleMollieConnectClick}
                    />
                  </Typography>
                </div>
                <div>
                  <Typography
                    style={{
                      background: "rgb(236, 239, 241)",
                      padding: 10,
                      borderRadius: 5,
                      marginTop: 20,
                      marginBottom: 20,
                    }}
                  >
                    <InfoIcon style={{ height: 15, width: 15 }} />
                    {" " + languages.signupPage.mollieConnectedDescription}
                    <IconButton
                      size="small"
                      aria-label="Open"
                      target="_blank"
                      href={languages.signupPage.mollieConnectedDescriptionURL}
                    >
                      <LaunchIcon />
                    </IconButton>
                  </Typography>
                </div>
              </div>
            ) : this.props.authLoaded ? (
              <div>
                <Typography style={{ marginBottom: 15 }}>
                  {languages.signupPage.onlinePaymentDescription}
                </Typography>
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  {languages.signupPage.onlinePaymentStep1}
                </Typography>
                <Typography>
                  {languages.signupPage.onlinePaymentStep1Description1}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={languages.signupPage.onlinePaymentStep1Description3}
                  >
                    {languages.signupPage.onlinePaymentStep1Description2}
                  </a>{" "}
                  {languages.signupPage.onlinePaymentStep1Description4}{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={languages.signupPage.onlinePaymentStep1Description5}
                  >
                    {languages.signupPage.onlinePaymentStep1Description6}
                  </a>
                  .
                </Typography>
                <Typography
                  style={{
                    background: "rgb(236, 239, 241)",
                    padding: 10,
                    borderRadius: 5,
                    marginTop: 10,
                    marginBottom: 20,
                  }}
                >
                  <InfoIcon style={{ height: 15, width: 15 }} />
                  {" " + languages.signupPage.onlinePaymentStep1Description7}
                </Typography>
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  {languages.signupPage.onlinePaymentStep2}
                </Typography>
                <Typography>
                  {languages.signupPage.onlinePaymentStep2Description}
                </Typography>
                <br />
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  {languages.signupPage.onlinePaymentStep3}
                </Typography>
                <Typography>
                  {languages.signupPage.onlinePaymentStep3Description}
                </Typography>
                <br />
                <img
                  src={mollie_button}
                  alt=""
                  style={{ cursor: "pointer", width: 209, height: 46 }}
                  onClick={this.props.handleMollieConnectClick}
                />
              </div>
            ) : (
              <div />
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
